import { Link } from 'react-router-dom';
import { InstallGuide } from '../components/InstallGuide';

/** Girişten önce de açılabilen kurulum sayfası: /kur. Bağlantı çalışanlarla paylaşılabilir. */
export function InstallScreen() {
  return (
    <div className="login-wrap">
      <div className="login-box stack" style={{ maxWidth: 520 }}>
        <img src="/icons/icon-512.png" alt="aksanenerji logosu" />
        <h1 className="center">aksanenerji</h1>
        <p className="center muted" style={{ marginTop: -8 }}>Uygulamayı cihazınıza kurun</p>
        <InstallGuide showAll />
        <p className="small muted">
          Tek uygulama tüm cihazlarda çalışır: Android telefon ve tablet, iPhone ve iPad, Windows, Mac ve Linux bilgisayar.
          Mağazadan indirme veya ayrı dosya kurulumu gerekmez. Hesabınızla girdiğiniz her cihazda aynı kayıtları görürsünüz.
        </p>
        <p className="center small"><Link to="/giris">Giriş ekranına dön</Link></p>
      </div>
    </div>
  );
}
